module.exports = __webpack_public_path__ + "assets/img/11.49bac849.png";